import React from 'react';
import { Link } from 'react-router-dom';
import { Download, RefreshCw, ArrowUpRight } from './icons';
import './UpdateBanner.css';

export default function UpdateBanner({ isUpdating, onUpdate, onDismiss }) {
  return (
    <aside className="update-notice" dir="rtl" aria-labelledby="update-notice-title" aria-busy={isUpdating}>
      <div className="update-notice__glow" aria-hidden="true" />
      <div className="update-notice__heading">
        <span className="update-notice__icon"><RefreshCw size={26} /></span>
        <div>
          <span className="update-notice__eyebrow">نسخه تازه ESF Gold</span>
          <h2 id="update-notice-title">وقت یک تجربه تازه است</h2>
        </div>
        <span className="update-notice__badge">آماده دریافت</span>
      </div>
      <p className="update-notice__description">به‌روزرسانی جدید آماده است. با یک لمس، نسخه تازه را اجرا کنید.</p>
      <p className="update-notice__hint">ابتدا کار جاری را تمام کنید؛ صفحه هنگام به‌روزرسانی دوباره باز می‌شود.</p>
      <div className="update-notice__actions">
        <button className="update-notice__primary" onClick={onUpdate} disabled={isUpdating}>
          {isUpdating ? <RefreshCw className="update-notice__spinner" size={19} /> : <Download size={19} />}
          <span aria-live="polite">{isUpdating ? 'در حال به‌روزرسانی…' : 'دریافت نسخه جدید'}</span>
        </button>
        <button className="update-notice__later" onClick={onDismiss} disabled={isUpdating}>بعداً</button>
        <Link className="update-notice__details" to="/version-info">اطلاعات نسخه <ArrowUpRight size={16} /></Link>
      </div>
    </aside>
  );
}
